import React from 'react';
import { type Locale, type TranslationParams } from './i18n';

export interface LanguageContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string, params?: TranslationParams) => string;
}

export const LanguageContext = React.createContext<LanguageContextType | undefined>(undefined);
